// import Splabieblab from "./Filters/DateRangePicker";
import DateRangeFilter from "./Filters/DateRangeFilter";
import DaWFilter from "./Filters/Product/DaWFilter";
import InboundRelationFilter from "./Filters/Inbound/InboundRelationFilter";
import OrderStatusFilter from "./Filters/Order/OrderStatusFilter";
import ProductFilter from "./Filters/Order/ProductFilter";
import RelationFilter from "./Filters/Order/RelationFilter";
import ShipperFilter from "./Filters/Order/ShipperFilter";
import StreamFilter from "./Filters/Order/StreamFilter";
import ReturnRelationFilter from "./Filters/Return/ReturnRelationFilter";
import StockFilterBasic from "./Filters/Product/StockFilterBasic";
import ProductActiveStateFilter from "./Filters/Product/ProductActiveStateFilter";
import InvoiceStateFilter from "./Filters/Invoice/InvoiceStateFilter";
import PostponedStreamFilter from "./Filters/Order/PostponedStreamFilter";
import BackorderStreamFilter from "./Filters/Order/BackorderStreamFilter";
import ReplenishStreamFilter from "./Filters/Order/ReplenishStreamFilter";
import LineWithAcceptedCount from "./Filters/Return/LineWithAcceptedCount";
import LineWithRejectedCount from "./Filters/Return/LineWithRejectedCount";
import ReturnStateFilter from "./Filters/Return/ReturnStateFilter";
import ReturnPaymentTypeFilter from "./Filters/Return/ReturnPaymentTypeFilter";
import QuarantineStockFilter from "./Filters/Stock/QuarantineStockFilter";
import InvoiceProductTypeFilter from "./Filters/InvoiceProduct/InvoiceProductTypeFilter";
import InboundStateFilter from "./Filters/Inbound/InboundStateFilter";
import ReplenishListStateFilter from "./Filters/States/ReplenishListStateFilter";
import InvoiceMutationStateFilter from "./Filters/States/InvoiceMutationStateFilter";
import { general_states } from "../../../utils/staticEnums";
import GeneralStateFilter from "./Filters/States/GeneralStateFilter";
import GeneralShipperFilter from "./Filters/General/GeneralShipperFilter";
import CostTypeFilter from "./Filters/Cost/CostTypeFilter";
import CostInvoiceTypeFilter from "./Filters/Cost/CostInvoiceTypeFilter";
import WarehouseFilter from "./Filters/General/WarehouseFilter";
import PastOrderFilter from "./Filters/Order/PastOrderFilter";
import DynamicTypeFilter from "./Filters/General/DynamicTypeFilter";
import { claimStatusFilterOptions } from "../../../utils/labelColorText";
import GeneralShipperProfileFilter from "./Filters/General/GeneralShipperProfileFilter";
import GeneralAllToggleFilter from "./Filters/General/GeneralAllToggleFilter";
import GeneralNumberRangeFilter from "./Filters/General/GeneralNumberRangeFilter";
import InvoiceProductFilter from "./Filters/Invoice/InvoiceProductFilter";
import UserFilter from "./Filters/General/UserFilter";
import SupplierFilter from "./Filters/General/SupplierFilter";
import GeneralCountryFilter from "./Filters/General/GeneralCountryFilter";
import WebshopCredentialsFilter from "./Filters/Order/WebshopCredentialsFilter";
import GeneralSelectFilter from "./Filters/General/GeneralSelectFilter";
import { useGetInvoiceProductCategorySelectQuery } from "../../../newapi/financial/invoiceProductCategorySlice";
import { useGetWarehouseZonesSelectQuery } from "../../../newapi/warehouse/warehouseApiSlice";
import { useGetWarehouseLocationTypesSelectQuery } from "../../../newapi/warehouse/warehouseLocationTypeSlice";


export const ORDER_FILTER_KEYS = {
    ALL_STATES: {
        header:'state',
        backend_key: 'state',
        component: OrderStatusFilter
    },
    ALL_STATES_RELATION: {
        header:'state',
        backend_key: 'state',
        component: OrderStatusFilter,
        params: { isRelation: true }
    },
    STATE: {
        header:'state',
        backend_key: 'state',
        component: OrderStatusFilter,
        params: { processStates: true }
    },
    PROCESS_STATE: {
        header:'state',
        backend_key: 'state',
        component: OrderStatusFilter,
        params: { processStates: true }
    },
    STREAM: {
        header:'stream',
        backend_key:"streamId",
        component:StreamFilter
    },
    BACKORDERSTREAM: {
        header:'stream',
        backend_key:"streamId",
        component:BackorderStreamFilter,
    },
    REPLENISHSTREAM: {
        header:'stream',
        backend_key:"streamId",
        component:ReplenishStreamFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:ShipperFilter,
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    EXCLUDE_RELATION: {
        header:'exclude_relation',
        backend_key:"excludeRelationId",
        component:RelationFilter,
        params: { backend_key: "excludeRelationId"}
    },
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    PAST_ORDERS: {
        header:"date_planned_past",
        backend_key:"pastOrders",
        component: PastOrderFilter,
    },
    B2B_ORDERS: {
        header:"b2b_orders",
        backend_key:"b2bOrders",
        component: GeneralAllToggleFilter,
        params: { key: "b2bOrders", toggleLabel: "only_b2b" }
    },
    COUNTRY :{
        header:'country',
        backend_key:"country",
        component:GeneralCountryFilter,
    },
    WEBSHOP :{
        header:'saleschannel',
        backend_key:"webshopCredentialsId",
        component: WebshopCredentialsFilter,
    },
}; 

export const REPLENISH_FILTER_KEYS = {
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:ShipperFilter,
        params: { states: [general_states.REPLENISH] }
    },
    STREAM: {
        header:'stream',
        backend_key:"streamId",
        component:StreamFilter,
        params: { states: [general_states.REPLENISH] }
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    B2B_ORDERS: {
        header:"b2b_orders",
        backend_key:"b2bOrders",
        component: GeneralAllToggleFilter,
        params: { key: "b2bOrders", toggleLabel: "only_b2b" }
    },
}; 

export const REPLENISHLIST_FILTER_KEYS = {
    STATE: {
        header:'state',
        backend_key: 'state',
        component: ReplenishListStateFilter
    },
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    WAREHOUSE: {
        header:'warehouse',
        backend_key:"warehouseId",
        component:WarehouseFilter,
    },
}; 

export const ORDER_POSTPONED_FILTER_KEYS = {
    STREAM: {
        header:'stream',
        backend_key:"streamId",
        component:StreamFilter,
        params: { postponed: true }
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:ShipperFilter,
        params: { postponed: true }
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    B2B_ORDERS: {
        header:"b2b_orders",
        backend_key:"b2bOrders",
        component: GeneralAllToggleFilter,
        params: { key: "b2bOrders", toggleLabel: "only_b2b" }
    },
    TOMORROW_DATE: {
        header:"date_tomorrow",
        backend_key:"isTomorrow",
        component: GeneralAllToggleFilter,
        params: { key: "isTomorrow", toggleLabel: "tomorrow" }
    },
}; 

export const SHIPPED_FILTER_KEYS = {
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:ShipperFilter,
        params: { ignorecount: true }
    },
    STREAM: {
        header:'stream',
        backend_key:"streamId",
        component:StreamFilter,
        params: { ignorecount: true }
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    B2B_ORDERS: {
        header:"b2b_orders",
        backend_key:"b2bOrders",
        component: GeneralAllToggleFilter,
        params: { key: "b2bOrders", toggleLabel: "only_b2b" }
    },
    COUNTRY :{
        header:'country',
        backend_key:"country",
        component:GeneralCountryFilter,
    },
}; 

export const SNOOZED_FILTER_KEYS = {
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:ShipperFilter,
        params: { states: [general_states.SNOOZE] }
    },
    STREAM: {
        header:'stream',
        backend_key:"streamId",
        component:StreamFilter,
        params: { states: [general_states.SNOOZE] }
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    B2B_ORDERS: {
        header:"b2b_orders",
        backend_key:"b2bOrders",
        component: GeneralAllToggleFilter,
        params: { key: "b2bOrders", toggleLabel: "only_b2b" }
    },
}; 

export const AR_CUSTOMER_FILTER_KEYS = {
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:ShipperFilter,
        params: { states: [general_states.ACTION_REQUIRED_CUSTOMER] }
    },
    STREAM: {
        header:'stream',
        backend_key:"streamId",
        component:StreamFilter,
        params: { states: [general_states.ACTION_REQUIRED_CUSTOMER] }
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    B2B_ORDERS: {
        header:"b2b_orders",
        backend_key:"b2bOrders",
        component: GeneralAllToggleFilter,
        params: { key: "b2bOrders", toggleLabel: "only_b2b" }
    },
}; 

export const BACKORDER_FILTER_KEYS = {
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:ShipperFilter,
        params: { states: [general_states.BACKORDERED] }
    },
    STREAM: {
        header:'stream',
        backend_key:"streamId",
        component:StreamFilter,
        params: { states: [general_states.BACKORDERED] }
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    B2B_ORDERS: {
        header:"b2b_orders",
        backend_key:"b2bOrders",
        component: GeneralAllToggleFilter,
        params: { key: "b2bOrders", toggleLabel: "only_b2b" }
    },
}; 

export const CANCELLED_FILTER_KEYS = {
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:ShipperFilter,
        params: { states: [general_states.CANCELLED], ignorecount: true }
    },
    STREAM: {
        header:'stream',
        backend_key:"streamId",
        component:StreamFilter,
        params: { states: [general_states.CANCELLED], ignorecount: true }
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    B2B_ORDERS: {
        header:"b2b_orders",
        backend_key:"b2bOrders",
        component: GeneralAllToggleFilter,
        params: { key: "b2bOrders", toggleLabel: "only_b2b" }
    },
}; 

export const BOL_FILTER_KEYS = {
    STATE: {
        header:'state',
        backend_key: 'state',
        component: GeneralStateFilter,
        params: { type: "bolreplenish" }
    },
};

export const AMAZON_FILTER_KEYS = {
    STATE: {
        header:'state',
        backend_key: 'state',
        component: GeneralStateFilter,
        params: { type: "amazonreplenish" }
    },
};

export const INBOUND_FILTER_KEYS = {
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:InboundRelationFilter,
    },
    STATE: {
        header:'state',
        backend_key:"state",
        component:InboundStateFilter,
    },
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    SUPPLIER: {
        header:'supplier',
        backend_key:"supplierId",
        component:SupplierFilter,
    },
}

export const RETURN_FILTER_KEYS = {
    STATE: {
        header:'state',
        backend_key: 'state',
        component: GeneralStateFilter,
        params: { type: "return" }
    },
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:ReturnRelationFilter,
    },
    PAYMENT: {
        header:'type',
        backend_key:"paymentTypes",
        component:ReturnPaymentTypeFilter,
    }
}

export const RETURNLINE_FILTER_KEYS = {
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:ReturnRelationFilter,
    },
    RETURN_STATE :{
        header:'return_state',
        backend_key:"returnState",
        component:ReturnStateFilter,
    },
    ACCEPTED_COUNT :{
        header:'with_accepted',
        backend_key:"withAccepted",
        component:LineWithAcceptedCount,
    },
    REJECTED_COUNT :{
        header:'with_rejected',
        backend_key:"withRejected",
        component:LineWithRejectedCount,
    },
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
}

export const PRODUCT_FILTER_KEYS = {
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:ReturnRelationFilter,
    },
    PRODUCTDIMENSIONS: {
        header:"dimensions_and_weight",
        backend_key:"withoutDaW",
        component: DaWFilter,
    },
    STOCK: {
        header:"stock",
        backend_key:"withStock",
        component: StockFilterBasic,
    },
    QUARANTINE: {
        header:"with_quarantine",
        backend_key:"withQuarantine",
        component: GeneralAllToggleFilter,
        params: { key: "withQuarantine", toggleLabel: "with_quarantine" }
    },
    SAFETY_STOCK: {
        header:"below_safetystock",
        backend_key:"belowSafetyStock",
        component: GeneralAllToggleFilter,
        params: { key: "belowSafetyStock", toggleLabel: "below_safetystock" }
    },
    STATE:{
        header:"state",
        backend_key:"showInactive",
        component:ProductActiveStateFilter,
    },
    BACKORDER_WITH_INBOUND: {
        header:"backorder_with_inbound",
        backend_key:"backorderWithInbound",
        component: GeneralAllToggleFilter,
        params: { key: "backorderWithInbound", toggleLabel: "label_backorder_with_inbound" }
    },
    BACKORDER_WITHOUT_INBOUND: {
        header:"backorder_without_inbound",
        backend_key:"backorderWithoutInbound",
        component: GeneralAllToggleFilter,
        params: { key: "backorderWithoutInbound", toggleLabel: "label_backorder_without_inbound" }
    },
    ADDON: {
        header:"is_addon",
        backend_key:"isAddon",
        component: GeneralAllToggleFilter,
        params: { key: "isAddon", toggleLabel: "is_addon" }
    },
    SERIALNUMBER: {
        header:"with_serialnumbers",
        backend_key:"serialNumberRequired",
        component: GeneralAllToggleFilter,
        params: { key: "serialNumberRequired", toggleLabel: "with_serialnumbers" }
    },
    SUPPLIER: {
        header:'supplier',
        backend_key:"supplierId",
        component:SupplierFilter,
    },
}

export const STOCK_FILTER_KEYS = {
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:ReturnRelationFilter,
    },
    QUARANTINE: {
        header:"with_quarantine",
        backend_key:"withQuarantine",
        component: QuarantineStockFilter,
    },
    WITHOUT_STOCK: {
        header:"without_stock",
        backend_key:"withoutStock",
        component: GeneralAllToggleFilter,
        params: { key: "withoutStock", toggleLabel: "without_stock" }
    },
}

// ABC pick analysis. The labels are cut on all products, these filters only narrow the view.
export const ABC_FILTER_KEYS = {
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:ReturnRelationFilter,
    },
    WAREHOUSE_ZONE: {
        header:'warehouse_zone',
        backend_key:"warehouseZoneId",
        component:GeneralSelectFilter,
        params: {
            query: useGetWarehouseZonesSelectQuery,
            backendKey: "warehouseZoneId",
            displayName: "description",
            dataKey: "data",
        }
    },
    LOCATION_TYPE: {
        header:'location_type',
        backend_key:"warehouseLocationTypeId",
        component:GeneralSelectFilter,
        params: {
            query: useGetWarehouseLocationTypesSelectQuery,
            backendKey: "warehouseLocationTypeId",
            displayName: "description",
            dataKey: "data",
        }
    },
    // The warehouse of the product's relation, only shown with two or more active picking warehouses
    WAREHOUSE: {
        header:'warehouse',
        backend_key:"warehouseId",
        component:WarehouseFilter,
    },
    LABEL: {
        header:'abc_label',
        backend_key:"abcLabel",
        component:DynamicTypeFilter,
        params: { key: "abcLabel", options: [
            {
                label: "abc_label_a",
                value: "A",
                color: "green"
            },
            {
                label: "abc_label_b",
                value: "B",
                color: "orange"
            },
            {
                label: "abc_label_c",
                value: "C",
                color: "grey"
            }
        ] }
    },
};

export const STOCK_MUTATION_FILTER_KEYS = {
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    TYPE :{
        header:'type',
        backend_key:"type",
        component:DynamicTypeFilter,
        params: { 
            key: "type", 
            options: [
                {
                    label: "manual",
                    value: "Manual",
                    color: "blue"
                },
                {
                    label: "order",
                    value: "Outbound",
                    color: "green"
                },
                {
                    label: "return",
                    value: "Return",
                    color: "purple"
                },
                {
                    label: "inbound",
                    value: "Inbound",
                    color: "orange"
                }
            ] 
        }
    },
    WAREHOUSE: {
        header:'warehouse',
        backend_key:"warehouseId",
        component:WarehouseFilter,
    },
    USER: {
        header:'user',
        backend_key:"userId",
        component:UserFilter,
    },
    DATERANGE: {
        header: 'date',
        backend_key:'date',
        component: DateRangeFilter,
    },
}; 

export const BATCH_FILTER_KEYS = {
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:ReturnRelationFilter,
    },
    PRODUCT: {
        header:'product',
        backend_key:"productId",
        component:ProductFilter,
    },
}

export const INVOICE_FILTER_KEYS = {
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:ReturnRelationFilter,
    },
    STATE:{
        header:"state",
        backend_key:"showInactive",
        component:InvoiceStateFilter,
    },
    // Sent or reminded invoices whose due date has passed.
    OVERDUE:{
        header:"due_date",
        backend_key:"overdue",
        component:DynamicTypeFilter,
        params: { key: "overdue", options: [
            {
                label: "overdue",
                value: true,
                color: "red"
            }
        ] }
    }
}

// Claims. The relation list folds "replied" into "sent" — an unreleased reply is not something
// the customer is shown — so their filter offers no option for it.
export const CLAIM_FILTER_KEYS = {
    CLAIM_STATUS: {
        header: 'status',
        backend_key: "claimStatus",
        component: DynamicTypeFilter,
        params: { key: "claimStatus", options: claimStatusFilterOptions }
    },
    RELATION: {
        header: 'relation',
        backend_key: "relationId",
        component: ReturnRelationFilter,
    },
};

export const RELATION_CLAIM_FILTER_KEYS = {
    CLAIM_STATUS: {
        header: 'status',
        backend_key: "claimStatus",
        component: DynamicTypeFilter,
        params: { key: "claimStatus", options: claimStatusFilterOptions.filter(option => option.value !== "replied") }
    },
};

export const SHIPMENTS_FILTER_KEYS = {
    SHIPPER :{
        header:'shipper',
        backend_key:"shipperId",
        component:GeneralShipperFilter,
    },
     SHIPPER_PROFILE :{
        header:'shipper_profile',
        backend_key:"shipperProfileId",
        component:GeneralShipperProfileFilter,
    },
    TYPE :{
        header:'type',
        backend_key:"type",
        component:DynamicTypeFilter,
        params: { key: "type", options: [
            {
                label: "order",
                value: "standard",
                color: "blue"
            },
            {
                label: "return",
                value: "return",
                color: "orange"
            },
            {
                label: "individual_shipment",
                value: "relation",
                color: "purple"
            }
        ] }
    },
    SHIPMENT_STATUS :{
        header:'shipment_status',
        backend_key:"shipmentStatus",
        component:DynamicTypeFilter,
        params: { key: "shipmentStatus", options: [
            {
                label: "underway",
                value: "underway",
                color: "blue"
            },
            {
                label: "delivered",
                value: "delivered",
                color: "green"
            },
            {
                label: "not_delivered",
                value: "not_delivered",
                color: "red"
            },
            {
                label: "not_fetched",
                value: "not_fetched",
                color: "orange"
            }
        ] }
    },
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:ReturnRelationFilter,
    },
    COUNTRY :{
        header:'country',
        backend_key:"country",
        component:GeneralCountryFilter,
    },
    ORDERS_WITH_MULTIPLE: {
        header:"orders_with_multiple_shipments",
        backend_key:"ordersWithMultipleShipments",
        component: GeneralAllToggleFilter,
        params: { key: "ordersWithMultipleShipments", toggleLabel: "multiple_shipments" }
    },
}

export const INVOICE_PRODUCT_FILTER_KEYS = {
    PRODUCT_TYPE:{
        header:"type",
        backend_key:"type",
        component:InvoiceProductTypeFilter,
    },
    PRODUCT_CATEGORY:{
        header:"product_category",
        backend_key:"invoiceProductCategoryId",
        component:GeneralSelectFilter,
        params: {
            query: useGetInvoiceProductCategorySelectQuery,
            backendKey: "invoiceProductCategoryId",
            displayName: "name",
        }
    }
}

export const COST_FILTER_KEYS = {
    TYPE:{
        header:"type",
        backend_key:"type",
        component:CostTypeFilter,
    },
    INVOICE_TYPE:{
        header:"invoice_type",
        backend_key:"invoiceType",
        component:CostInvoiceTypeFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:GeneralShipperFilter,
    },
}

export const INVOICE_WITHOUT_COST_KEYS = {
    DATERANGE: {
        header: 'date',
        backend_key:'date',
        component: DateRangeFilter,
    },
    RELATION :{
        header:'relation',
        backend_key:"relationId",
        component:ReturnRelationFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:GeneralShipperFilter,
    },
    STREAM: {
        header:'stream',
        backend_key:"streamId",
        component:StreamFilter,
        params: { ignorecount: true }
    },
}

export const INVOICEMUTATIONS_FILTER_KEYS = {
    STATE:{
        header:"state",
        backend_key:"state",
        component:InvoiceMutationStateFilter,
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    INVOICE_PRODUCT: {
        header:'invoice_product',
        backend_key:"invoiceProductId",
        component:InvoiceProductFilter,
    },
}

export const INVOICE_SHIPPING_COSTS = {
    DATERANGE: {
        header: 'date',
        backend_key:'date',
        component: DateRangeFilter,
    },
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:GeneralShipperFilter,
    },
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    COUNTRY :{
        header:'country',
        backend_key:"country",
        component:GeneralCountryFilter,
    },
    NEGATIVE_BALANCE: {
        header:"negative_balance",
        backend_key:"negativeBalance",
        component: GeneralAllToggleFilter,
        params: { key: "negativeBalance", toggleLabel: "negative_balance" }
    },
    SALDO: {
        header:"saldo",
        backend_key:"saldo",
        component: GeneralNumberRangeFilter,
        // Money, so cents are allowed, and negative: a saldo below zero is the one being
        // looked for.
        params: { key: "saldo", unit: "€", step: 0.01, allowNegative: true }
    },
    WEIGHT: {
        header:"warehouse_weight",
        backend_key:"weight",
        component: GeneralNumberRangeFilter,
        params: { key: "weight", unit: "g" }
    },
}

export const SHIPPERPROFILE_FILTER_KEYS = {
    SHIPPER: {
        header:'shipper',
        backend_key:"shipperId",
        component:GeneralShipperFilter,
    },
}

export const WEBSHOP_FILTER_KEYS = {
    RELATION: {
        header:'relation',
        backend_key:"relationId",
        component:RelationFilter,
    },
    WAREHOUSE: {
        header:'warehouse',
        backend_key:"warehouseId",
        component:WarehouseFilter,
    },
}

export const RELATION_FILTER_KEYS = {
    STATE: {
        header:'state',
        backend_key:"state",
        component:DynamicTypeFilter,
        params: { key: "state", options: [
            {
                label: "active",
                value: "active",
                color: "blue"
            },
            {
                label: "inactive",
                value: "inactive",
                color: "orange"
            },
            {
                label: "deleted",
                value: "deleted",
                color: "red"
            },
            {
                label: "blocked",
                value: "blocked",
                color: "purple"
            }
        ] }
    },
    CUSTOM_CUTOFF: {
        header:"custom_cutoff",
        backend_key:"customCutoff",
        component: GeneralAllToggleFilter,
        params: { key: "customCutoff", toggleLabel: "custom_cutoff" }
    },
}